<template>
  <div class="root-container">
    <div class="news-main-container" :class="{shown : IsShown}">
      <button class="show-news-button glass-background">
        <span @click="ToggleMenu(!IsShown)" class="action" :class="{NoRightBorder : !IsShown}">
          <span class="menu-indicator"></span>
          News of Technology
        </span>

        <span
          class="news-actions-container action"
          :style="{ display :  IsShown ? 'initial' : 'none' }"
        >
          <i
            class="fas fa-play"
            @click="ChangePlayState(false); PauseClicked = false"
            :class="{active : !Paused}"
            v-if="IsShown"
          ></i>
          <i
            class="fas fa-pause"
            @click="ChangePlayState(true); PauseClicked = true"
            :class="{active : Paused}"
            v-if="IsShown"
          ></i>
        </span>

        <span
          class="news-board-btn action"
          @click="ToggleNewBoardStatus(true)"
          :style="{ display :  IsShown ? 'initial' : 'none' }"
        >
          News Board
          <i class="fas fa-angle-up news-board-arrow" v-if="IsShown"></i>
        </span>
      </button>

      <div class="__news-bar">
        <marquee-text :duration="100" :paused="Paused">
          <div
            class="__marquee"
            v-touch:start="NewsTouchStart"
            v-touch:moving="NewTouchMoving"
            @mouseup="NewsMouseUp"
          >
            <p
              v-for="(item , index) in News"
              :key="index"
              @mouseenter="NewsMouseEntered"
              @mouseleave="NewsMouseOut"
            >
              <span>
                <a :href="item.url" target="_blank">▶</a> &nbsp;
              </span>
              <span class="newsTitle">{{item.title}}</span>
            </p>
          </div>
        </marquee-text>
      </div>
    </div>
    <NewsBoard v-if="NewsListShow" :shown="NewsListShowDelayed" @closed="ToggleNewBoardStatus(false)" />
  </div>
</template>

<script>
import MarqueeText from "vue-marquee-text-component";
import NewsBoard from "./newsBoard";
import newsMixin from "../../mixins/newsMixin";
import MainStore from "../../stores/MainStore";
import { mapMutations, mapState } from "vuex";

export default {
  components: {
    NewsBoard,
    MarqueeText,
  },

  store: MainStore,

  mixins: [newsMixin],

  data() {
    return {
      IsShown: false,
      News: [],
      Paused: true,
      PauseClicked: false,
      NewsPreviousPoints: null,
    };
  },

  created: function () {
    // show news bar by default if it's not mobile
    if (!this.$isMobile()) this.ToggleMenu(true);

    document.body.onmousemove = this.NewTouchMoving;
    document.body.ontouchmove = this.NewTouchMoving;
    document.body.onmouseup = this.NewsMouseUp;
    document.body.ontouchend = this.NewsMouseUp;
  },

  methods: {
    ...mapMutations(["ToggleNewBoardStatus"]),
    ToggleMenu: function (showOrHide) {
      this.$emit("BarStatusChanged", showOrHide);
      if (!showOrHide) {
        this.IsShown = false;
        this.Paused = true;
      } else {
        this.IsShown = true;
        var self = this;

        this.GetNews(null, function (response) {
          self.News = response.body.articles.slice(0 , 20);
          self.Paused = false;
          self.$forceUpdate();
        });
      }
    },

    NewsMouseEntered: function () {
      if (this.PauseClicked) return;
      this.ChangePlayState(true);
    },

    NewsMouseOut: function () {
      if (this.PauseClicked) return;
      this.ChangePlayState(false);
    },

    ChangePlayState: function (Paused) {
      this.Paused = Paused;

      // next for resume the animation sliding effect in marquee
      var targetElement = document.querySelector(".marquee-text-text");
      if (!Paused) {
        var oldStyle = targetElement.getAttribute("style");
        targetElement.setAttribute(
          "style",
          oldStyle + ";animation-duration: 100s;"
        );
      }

      this.$forceUpdate();
    },

    // touch news
    NewsTouchStart: function (e) {
      if (!this.$isMobile()) e.preventDefault();

      // get start points
      var currentPoints =
        typeof e.changedTouches !== "undefined" ? e.changedTouches[0] : e;
      // pause news merquee
      this.ChangePlayState(true);
      // store the current points
      this.NewsPreviousPoints = {
        x: currentPoints.pageX,
        y: currentPoints.pageY,
      };
    },

    NewTouchMoving: function (e) {
      // check whether the user is still dragging
      if (this.NewsPreviousPoints == null) return;

      // get the marquee transform matrix
      var targetElement = document.querySelector(".marquee-text-text");
      var computedStyle = window.getComputedStyle(targetElement, null);
      var transform =
        computedStyle.getPropertyValue("-webkit-transform") ||
        computedStyle.getPropertyValue("-moz-transform") ||
        computedStyle.getPropertyValue("-ms-transform") ||
        computedStyle.getPropertyValue("-o-transform") ||
        computedStyle.getPropertyValue("transform");

      var matrix = this.matrixToArray(transform);

      // get the translateX value from the matrix (5th item)
      var xTranslate = Number.parseFloat(matrix[4]);

      // get current fingered points
      var currentPoints =
        typeof e.changedTouches !== "undefined" ? e.changedTouches[0] : e;

      // new x location will be the previous x minus the current one
      var delta = currentPoints.pageX - this.NewsPreviousPoints.x;
      matrix[4] = xTranslate + delta;
      var matrixJoined = matrix.join(",");

      // set the new transformation style
      targetElement.setAttribute(
        "style",
        `-webkit-transform : matrix(${matrixJoined});
        -moz-transform: matrix(${matrixJoined});
        -ms-transform: matrix(${matrixJoined});
        -o-transform: matrix(${matrixJoined});
         transform : matrix(${matrixJoined});;
        `
      );

      // update the current stored points to new one
      this.NewsPreviousPoints = {
        x: currentPoints.pageX,
        y: currentPoints.pageY,
      };
    },

    NewsMouseUp: function () {
      this.NewsPreviousPoints = null;
    },


    matrixToArray: function (matrix) {
      return matrix.substr(7, matrix.length - 8).split(", ");
    },
  },

  computed : {
    ...mapState([
      "NewsListShow" , 
      "NewsListShowDelayed"
    ])
  }
};
</script>

<style>
/* crossed */

.no-animation {
  -ms-transform: none !important;
  -webkit-transform: none !important;
  transform: none !important;
}

.news-main-container {
  position: fixed;
  height: 36px;
  width: 100%;
  left: 0px;
  bottom: -4px;
  z-index: 99;
}

.news-main-container div,
.news-main-container span,
.news-main-container button,
.news-main-container a {
  outline: none;
}

.news-main-container.shown {
  bottom: 30px;
  -webkit-transition: 500ms ease-in-out;
  -o-transition: 500ms ease-in-out;
  transition: 500ms ease-in-out;
  -ms-transform: translate(0, -20);
  transform: translate(0, -20);
  -webkit-transform: translate(0, -20);
  -o-transform: translate(0, -20);
  -moz-transform: translate(0, -20);
}

.show-news-button {
  color: #aacbec;
  border: 0px;
  font-weight: bold;
  font-size: 13px;
  margin-left: 20px;
  background-color: rgb(24, 28, 33) !important;
  padding: 10px;
  padding-top: 7px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  cursor: pointer;
}

.news-main-container .show-news-button .menu-indicator::after {
  content: "▲";
}

.news-main-container.shown .show-news-button .menu-indicator::after {
  content: "▼";
}

.news-actions-container i {
  font-size: 12px;
  color: rgb(102 109 117);
}

.news-actions-container i.active {
  color: #aacbec;
}

.__news-bar {
  position: absolute;
  height: 35px;
  bottom: -30px;
  left: 0px;
  width: 100%;
  background-color: rgb(24, 28, 33);
}

.__marquee {
  color: white;
  white-space: nowrap;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 5px;
}

.__marquee p a {
  text-decoration: none;
  color: #aacbec;
}

.__marquee p span {
  margin-left: 30px;
  color: #aacbec;
}

.__marquee p span.newsTitle {
  margin-left: 3px;
}

.__marquee p a:hover {
  color: rgb(223, 33, 65);
}

.news-main-container.shown .__marquee p {
  display: inline-block;
}

.__marquee a,
.__marquee p {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.show-news-button .action {
  border-right: 2px solid #3f474e;
  margin-left: 15px;
  padding-right: 15px;
}

.news-actions-container i {
  padding-left: 10px;
  padding-right: 10px;
}

.NoRightBorder {
  border-right: 0px solid #3f474e !important;
}

.show-news-button .action:last-of-type {
  border-right: 0px solid red;
}

.news-board-arrow {
  font-size: 16px !important;
  position: relative;
  left: 7px;
  top: 2px;
}

.news-board-btn {
  color: #aacbec !important;
}
.news-board-btn:hover {
  color: #d46075 !important;
}

@media only screen and (max-width: 400px) {
  .show-news-button {
    font-size: 10px;
    padding: 8px;
    padding-left: 0px;
    margin-left: 10px;
  }

  .show-news-button i {
    font-size: 10px;
    padding: 6px;
  }

  .news-main-container {
    height: 36px;
  }
  .news-main-container.shown {
    height: 42px;
  }

  .news-board-btn:hover {
    color: #aacbec !important;
  }

  /* .news-actions-container i {
    padding-left: 0px;
    padding-right: 0px;
  } */
}
</style>